import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { hashHistory } from "react-router";
import {FormattedMessage} from "react-intl";

import { toggleSelectionWindow, toggleSelectionFeatureInfo, setVanityType } from '../../actions/actionFunctions';
import Analytics from './../../analytics';

class ProjectScopeDesktopSearchInput extends Component {

  static propTypes = {
    layout: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    }
  }

  handleSearchInputChange = (e) => {
    this.setState({
      searchText: e.target.value
    });
  };

  handleOnFocus = () => {
    document.body.classList.add('body--search');
    document.body.scrollTop = 0;
    setTimeout(() => {
      document.body.scrollTop = 0;
    }, 0);
  };

  handleOnBlur = () => {
    document.body.classList.remove('body--search');
  };

  goToItemInfo = (navItem) => {
    Analytics.sendClickEvent('go-to-item-info-' + navItem.part.partName);
    // console.log('navItem', navItem);
    const navItemParent = navItem.part.getParent();

    const parentSimple = (navItemParent.partName === "Floor" && navItemParent.partId !== "shower_floor")
      || navItemParent.partName === "Toilet"
      || (navItemParent.partName === "Ceiling" &&
      (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV"))
      || navItemParent.partName === "Window";
    this.props.setVanityType(true);
    this.props.toggleSelectionWindow(true, parentSimple ? navItemParent.partName : navItemParent.getParent().partName);
    this.props.toggleSelectionFeatureInfo(navItem.part);
    navItem.part.handleClick();
    hashHistory.push('materials');
  };

  render() {
    let navItems = this.props.layout.getAllFeaturesByText(this.state.searchText);
    // console.log(navItems);
    const dropDownItems = navItems.map((navItem, index) => {
      return (
        <li className="search-dropdown-list__item" key={"list-item"+index} onClick={() => this.goToItemInfo({
          part: navItem
        })}>
          {navItem.partName}
        </li>
      )
    });
    let style = {};
    const smallDropDown = (navItems.length > 0) && (navItems.length < 7);
    if (smallDropDown) {
      style.height = navItems.length * 30
    }
    return (
      <div className="search">
        <FormattedMessage id="projectScope.searchPlaceholder" defaultMessage="search">
          {(placeholder) => (
            <input type="text" className={"ui-input search-input" + (this.state.searchText ? " search-input--no-icon" : "")}
                   placeholder={placeholder}
                   value={this.state.searchText}
                   onChange={this.handleSearchInputChange}
                   onFocus={this.handleOnFocus}
                   onBlur={this.handleOnBlur}/>
          )}
        </FormattedMessage>
        <span className="search-icon"/>
        <div className={"search-dropdown" + (this.state.searchText && navItems.length ? " search-dropdown--opened" : "")}
             style={style}>
          <ul className={"search-dropdown-list" + (smallDropDown ? " search-dropdown-list--no-scroll" : "")}>
            {dropDownItems}
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {

  };
};

export default connect(mapStateToProps, {
  setVanityType,
  toggleSelectionWindow,
  toggleSelectionFeatureInfo
})(ProjectScopeDesktopSearchInput);
